<template>
  <div class="miniProgram w1200">
    <ul class="program-type flex justify-center">
      <li>
        <h1 class="text-center">已经拥有微信小程序</h1>
        <div class="mar64-t">
          <p>授权已有的微信小程序，完成设置发布，快速获得商城小程序</p>
          <p>支持模板选择~</p>
        </div>
        <div class="text-center">
          <el-button class="mar20-t" type="primary" @click="openAuthorization">授权微信小程序</el-button>
        </div>
      </li>
      <li>
        <h1 class="text-center">还没有微信小程序</h1>
        <el-tabs v-model="activeName">
          <el-tab-pane label="品牌小程序" name="1">
            <p>提交认证信息，快速创建小程序，支持模板选择~</p>
            <p>注：涉及法人相关的刷脸、验证码验证等(工商部备案、微信平台认证等)</p>
            <div class="text-center">
              <el-button class="mar20-t" type="primary" @click="openReg">快速注册小程序</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="通用小程序" name="2">
            <el-form
              ref="form"
              :model="form"
              :rules="rules"
              label-width="100px"
              label-suffix="："
              class="mar50-r"
              v-loading="shareLoading"
              element-loading-text="上传中"
            >
              <el-form-item label="经营描述" prop="shareDesc">
                <el-input v-model="form.shareDesc" maxlength="20" placeholder="请输入经营描述,20字以内" />
              </el-form-item>
              <el-form-item label="分享图" prop="shareImg">
                <el-upload
                  class="share-uploader"
                  :action="`${env.VUE_APP_fileserver}persistentUpload`"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :before-upload="uploadBefore"
                >
                  <img v-if="form.shareImg" :src="form.shareImg" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="gray9 lh20">建议尺寸500px*400px</div>
              </el-form-item>
              <el-form-item label="分享预览">
                <div class="pad15 radius10 bg-f2 lh20 w205">
                  <div class="flex items-center">
                    <div class="share-icon mar10-r"></div>
                    <div class="f14 gray6">下单易助手</div>
                  </div>
                  <div class="mar10-tb f15 gray3 ellipsis2">{{ form.shareDesc }}</div>
                  <div class="bg-white share-img radius5">
                    <img v-if="form.shareImg" :src="form.shareImg" />
                  </div>
                </div>
              </el-form-item>
              <!-- <el-form-item>
                <el-checkbox class="lh20" v-model="checked">通用小程序名称平台服务协议</el-checkbox>
              </el-form-item> -->
              <el-form-item class="text-center">
                <el-button type="primary" @click="submitForm" :loading="loading">确定创建</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
export default {
  data() {
    return {
      env: process.env,
      activeName: "1",
      form: {
        shareDesc: "",
        shareImg: "",
      },
      rules: {
        shareDesc: [{ required: true, message: "请输入经营描述", trigger: "blur" }],
        shareImg: [{ required: true, message: "请上传分享图", trigger: "change" }],
      },
      loading: false,
      shareLoading: false,
    };
  },
  created() {},
  methods: {
    openAuthorization() {
      this.$router.push(`/miniProgram/authorization/0`);
    },
    openReg() {
      this.$router.push(`/miniProgram/authorization/1`);
    },

    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50MB");
      } else {
        this.shareLoading = true;
      }
      return isVerify && isLt3M;
    },

    // 上传图片成功之后
    uploadSuccess(res) {
      const {
        data: { url },
      } = res;
      this.form.shareImg = url;
      const image = new Image();
      image.src = url;
      image.onload = () => {
        this.shareLoading = false;
      };
      console.log("this.form.shareImg", this.form.shareImg);
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // if (!this.checked) {
          //   this.$message.warning("请先同意通用小程序名称平台服务协议");
          //   return;
          // }
          this.loading = true;
          this.$store
            .dispatch("applet/applet/saveShopAppletInfo", this.form)
            .then((res) => {
              if (res.code === "0") {
                this.$message.success("开通成功");
                window.location.reload(true);
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
